document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector("[data-cascading-form-container-block]")) {
        import(/* webpackChunkName: "cascading-form-container-block" */ "/Features/Forms/js/cascading-form-container-block.js").then(async (module) => {
            const cascadingFormContainerBlock = new module.default();
            await cascadingFormContainerBlock.init();
        });
    }
});